import {useState,useEffect, useRef} from 'react'; 
import  Bredcrum  from '../../components/bredcrum';
import { Tag } from 'primereact/tag';
import {Tablescom} from '../../components/tablescomp';
import {userservices} from '../../services/userServices';
import {productservices} from '../../services/productServices';
import { saleServices } from "../../services/saleServices";
import { AlertServices } from '../../services/alertServices';
import {StockServices } from '../../services/stockServices';
import {Titlebar,Searchbox} from  '../../components/fieldsComp';
import { BrowserRouter, Routes, Route, useNavigate   } from "react-router";
import { Toast } from "primereact/toast";
const StockTracking = () =>{
    const toast = useRef(null);
    const navigate = useNavigate();
    const [users,setUsers] = useState([]);
    const [results,setResults] = useState([]);
    const [userloaded,setUserloaded] = useState(true);

    useEffect(()=>{
      getstocktrackinglist();
    },[]); 

  const [colDefs, setColDefs] = useState([
    { headerName: "SR NO",field: "id" },
    { headerName: "SKU code",field: "p_sku_code" },
    { headerName: "Product Name",field: "product_name" },
    { headerName: "Stock On Hand",field: "stock_on_hand" },
    { headerName: "Stock Needed",field: "stock_needed" },
    { headerName: "Discrepancy Alert",field: "discrepancy_alert" },
    { headerName: "Restock Alert Threshold",field: "restock_alert_threshold" },
    { headerName: "Stock Location",field: "stock_location" },
    { headerName: "Stock Type",field: "stock_type" },

    // { headerName: "Action",
    // cellRenderer: (params) => {
    //   return (
    //     <>
    //          <button class="btn  btn-sm btn-white custom-btn-color2" onClick={(e) => editredirect(params.data.id,params.data)}><i class="icon icon-note icon-style color-white"></i></button>
    //          <button class="btn btn-danger btn-sm btn-white btn-border-none" onClick={(e) => deletealert(params.data.id)}><i class="icon icon-trash" ></i></button> 
    //     </>
       
    //   );
    // } }
  ]);

  const editredirect = (id,alertData) =>{
    navigate(`/editalerts/${id}`, { state: { alert: alertData } });
  }
  const deletealert = (id) =>{
        AlertServices.deletealert(id).then((response)=>{
          if(response.status == 200){
            toast.current.show({ severity: 'success', summary: 'Alert', detail: 'Alert deleted successfully' }); 
            getstocktrackinglist();   
          }
      }).catch((error)=>{
        
      }); 
  }


  const getstocktrackinglist  = ()=> {
        // setUserloaded(false);
        StockServices.getstocktrackingdata().then((response)=>{
            console.warn(getstocktrackinglist);
            if(response.status == 200){
                setResults(response.data.data);
            }else{
              setResults([]);
                // setUsers([]);
                // setUserloaded(true);
            }  
        }).catch((error)=>{
          setResults([]);
            // setUsers([]);
            // setUserloaded(true);
        }); 
  } 

  const addalertnavigate = () =>{
    // navigate.  
    navigate('/addalerts');
  }

  return(
       <>
        <Toast ref={toast} />
          {/* <Bredcrum title={'Product'} divider={false}/> */}
          <div class="row">
              {/* <div className='col-md-12 mb-4 mt-4'>
                 <div className='flex-box flex-between'>
                      <button className='btn btn-primary rounded-pill custom-btn-color custom-btn-br-color ps-5 pe-5' onClick={() => addalertnavigate()}>Add New Alert & Reminders</button> 
                      <Searchbox/>
                  </div> 
              </div>  */}
             
              
              <Titlebar text={'Stock Tracking'}/>
              <div className="col-md-12 mt-3">
                  <div className='card'>
                    <div className='card-body card-body-style'>
                     <Tablescom rowdata={results} coldefs={colDefs} isloaded={userloaded}/>
                     </div>
                 </div>
              </div>   
          </div>
       </>
    );   
 }
 export default StockTracking;